import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from '@/layout/service/layout.service';

@Component({
    selector: 'auth-layout',
    standalone: true,
    imports: [RouterModule],
    template: `<div class="w-full min-h-screen">
        <main>
            <router-outlet></router-outlet>
        </main>
    </div>
    `,
})
export class AuthLayout {
    layoutService: LayoutService = inject(LayoutService);
}
